import { PlatformEnvironment } from '@mews/enums';
import { createHandler } from '@mews/std';

export const getEnvironmentBizzonApplicationIdHandler = createHandler<PlatformEnvironment, string>(
    {
        [PlatformEnvironment.Development]: '5f8a0136-97ef-4f9b-9530-aee000de295b',
        [PlatformEnvironment.Demo]: '8f9296ce-e7ff-4fc3-ad55-aeb400ea916e',
        [PlatformEnvironment.Production]: '2bf34fe3-2cb4-4939-931b-acb10086e90f',
        [PlatformEnvironment.Feature]: '5f8a0136-97ef-4f9b-9530-aee000de295b',
        [PlatformEnvironment.Test]: '5f8a0136-97ef-4f9b-9530-aee000de295b',
    },
    ''
);

export const getEnvironmentExpediaApplicationIdHandler = createHandler<PlatformEnvironment, string>(
    {
        [PlatformEnvironment.Development]: '00ef54a3-7ade-4490-80ce-b05400c3295d',
        [PlatformEnvironment.Demo]: 'cb350531-e9b5-4817-bca4-b08c00d62dd6',
        [PlatformEnvironment.Production]: 'ea1ca183-d675-404e-a80b-b05e008836bf',
        [PlatformEnvironment.Feature]: '00ef54a3-7ade-4490-80ce-b05400c3295d',
        [PlatformEnvironment.Test]: '00ef54a3-7ade-4490-80ce-b05400c3295d',
    },
    ''
);

export const getEnvironmentFlexkeepingApplicationIdHandler = createHandler<PlatformEnvironment, string>(
    {
        [PlatformEnvironment.Development]: '2c131cf7-2239-4e50-b24e-c342d173d981',
        [PlatformEnvironment.Demo]: '75c62e34-05cd-46d2-8baa-8d302f12f3be',
        [PlatformEnvironment.Production]: '2c131cf7-2239-4e50-b24e-c342d173d981',
        [PlatformEnvironment.Feature]: '2c131cf7-2239-4e50-b24e-c342d173d981',
        [PlatformEnvironment.Test]: '2c131cf7-2239-4e50-b24e-c342d173d981',
    },
    ''
);

export const getEnvironmentDigitalKeyApplicationIdHandler = createHandler<PlatformEnvironment, string>(
    {
        [PlatformEnvironment.Development]: '5b2cc8ab-df6c-4ebc-a2b1-b01a00956272',
        [PlatformEnvironment.Demo]: 'a53062a8-5c82-44f4-9440-b0c200c880a5',
        [PlatformEnvironment.Production]: 'ba6d4541-34a7-4b55-8a93-b0c200c739fc',
        [PlatformEnvironment.Feature]: '5b2cc8ab-df6c-4ebc-a2b1-b01a00956272',
        [PlatformEnvironment.Test]: '5b2cc8ab-df6c-4ebc-a2b1-b01a00956272',
    },
    ''
);
